export default __webpack_public_path__ + "static/media/instagram.23de8cda.svg";